import React from "react";
import styled from "styled-components";
import {TypeTitle, NameTitle, TextDescription, ContentContainer} from "./Products";
import {ButtonLink} from "./Button";
import Color from "../assets/Colors";
import parse from "html-react-parser";
import {IconTypeCourse} from "../components/IconType";
import {reverseDate} from "../constants/Helpers";

export default function Offer({data, description}) {
   return (
      <ItemsContainer>
         {Object.keys(data).map((x) => {
            const item = data[x];
            return (
               <ItemStyle key={item.idCourse} className="styleCarOffer">
                  {item.pathImageMobile ? (
                     <img src={"http://domecqapi.trebolbit.com/" + item.pathImageMobile} alt="course_img" className="img back" />
                  ) : (
                     <div className="imgSust" />
                  )}
                  <CardOffer>
                     <IconTypeCourse type={item.idCourseType} />
                     <TypeTitle className="subtitle">{item.courseType}</TypeTitle>
                     <ItemName>{item.courseName}</ItemName>
                     <InfoSectionDetails>
                        <div className="info">
                           <img src={require("../assets/icons/clock.png")} alt="icon" className="iconInfo" />
                           <div>
                              <TypeTitle size="0.9em" className="titleInfo">
                                 DURACIÓN
                              </TypeTitle>

                              {item.endDate ? (
                                 <ItemName className="nameInfo">{item.endDate} horas</ItemName>
                              ) : (
                                 <ItemName className="nameInfo">--</ItemName>
                              )}
                           </div>
                        </div>
                        <div className="info">
                           <img src={require("../assets/icons/calendar.png")} alt="icon" className="iconInfo" />
                           <div>
                              <TypeTitle size="0.9em" className="titleInfo">
                                 INICIO DEL CURSO
                              </TypeTitle>
                              {item.startDate ? (
                                 <ItemName className="nameInfo">{reverseDate(item.startDate)}</ItemName>
                              ) : (
                                 <ItemName className="nameInfo">--</ItemName>
                              )}
                           </div>
                        </div>
                     </InfoSectionDetails>
                     {description && <TextDescription>{item.shortDescription}</TextDescription>}
                     <ButtonLink to={`/${item.idCourseType === 5 ? "masterclass" : "cursos_esenciales"}/${item.idCourse}`}>
                        Conocer más 
                     </ButtonLink>
                  </CardOffer>
               </ItemStyle>
            );
         })}
      </ItemsContainer>
   );
}

Offer.defaultProps = {
   description: true,
};

export const ItemStyle = styled.div`
   width: 24.4%;
   box-sizing: border-box;
   display: flex;
   flex-direction: column;
   align-items: center;

   margin-bottom: 1em;

   &:nth-child(4n) {
      margin-right: 0;
   }

   & img {
      width: 100%;
   }

   & .imgSust {
      background: #394136;
      width: 100%;
      height: 100%;
      min-height: 223.02px;
   }

   @media screen and (max-width: 1600px) {
      width: 24.4%;
   }

   @media screen and (max-width: 800px) {
      width: 24.4%;
   }

   @media screen and (max-width: 500px) {
      width: 100%;
      margin-right: 0;
      & img.back {
         height: 320px;
         object-fit: cover;
      }
   }
`;
export const CardOffer = styled.div`
   width: 92%;
   background: white;
   padding: 2em 1em;
   margin-top: -4em;
   padding-bottom: 0;
   position: relative;

   & .iconDot {
      position: absolute;
      top: -1.5em;
      width: 3em;
      height: 3em;
   }
   & .subtitle {
      font-size: 0.8em;
   }
   @media screen and (max-width: 1600px) {
      padding: 1.5em 0.7em 0 0.7em;

      & .subtitle {
         font-size: 0.7em;
      }
      & .iconDot {
         position: absolute;
         top: -1.5em;
         width: 2.5em;
         height: 2.5em;
      }
   }
   @media screen and (max-width: 800px) {
      padding: 1.5em 0.4em 0 0.4em;
   }

   @media screen and (max-width: 500px) {
      margin-top: -5em;
      width: 97%;
      padding: 2em 0.7em;

      & ${ButtonLink} {
         background: ${Color.primary};
         color: white;
      }
   }
`;
export const InfoSectionDetails = styled.div`
   widht: 100%;
   padding: 0.5em 0;
   display: flex;
   justify-content: center;

   & .info {
      width: 40%;

      &:nth-child(2) {
         padding-left: 1em;
      }

      margin: 1em 0;

      & .iconInfo {
         width: 18px;
         height: 18px;
         margin-right: 0.5em;
         margin-bottom: 0.9em;
      }
   }

   & .titleInfo {
      font-size: 1em;
   }
   & .nameInfo {
      font-size: 1em;
   }
   & .info:last-child {
      width: 60%;
      border-left: 1px solid grey;
   }
   @media screen and (max-width: 1600px) {
      & .titleInfo {
         font-size: 0.75em;
      }
      & .nameInfo {
         font-size: 0.85em;
      }

      & .info {
         & .iconInfo {
            width: 15px;
            height: 15px;
            margin-bottom: 0.5em;
         }
      }
   }
`;
export const ItemsContainer = styled(ContentContainer)`
   display: flex;
   align-items: baseline;
   justify-content: space-around;
   flex-wrap: wrap;
   margin-top: 3em;

   & .styleCarOffer {
      margin-bottom: 130px;
   }

   @media screen and (max-width: 500px) {
      & .styleCarOffer {
         margin-bottom: 30px;
      }
   }
`;

export const ItemName = styled(NameTitle)`
   font-size: 0.9em;
   font-weight: 600;
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;

   @media screen and (max-width: 1600px) {
      font-size: 0.77em;
   }
   @media screen and (max-width: 500px) {
      font-size: 0.9em;
      margin-top: 0.3em;
   }
`;

export const DescriptionSection = styled.div`
   padding-top: 0.5em;
   padding-bottom: 1em;
   height: 7em;
   & ${TextDescription} {
      font-size: 0.9em;
   }
   @media screen and (max-width: 1600px) {
      height: 8em;
      & ${TextDescription} {
         font-size: 0.78em;
      }
   }
   @media screen and (max-width: 500px) {
      height: auto;
   }
`;
